/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./ToolbarAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../dashboard/util/ContentActionUtil'
], function(_, ToolbarAPI, APIFactory, ContentActionUtil) {
	//TODO: This module should be in Livewidget instead of Core (https://jsw.ibm.com/browse/CADBLOC-3075)
	class Toolbar {
		constructor(options){
			this._toolbarDock = options.features['Dashboard.ToolbarDock'];
			this._transaction = options.features['Dashboard.Transaction'];
			this._content = options.content;
			this.dashboard = options.features['Dashboard.API'];
			this.type = this.dashboard.getType();
			this._isExplore = this.type.toUpperCase()==='EXPLORE';
		}

		// this is needed so that the feature is not delay loaded therefore available for having the correct toolbar
		// actions for some visualizations.
		initialize() {
			if (!this._isExplore) {
				this._internalApi = APIFactory.createAPI(this, [ToolbarAPI]);
				this._content.on('change:visualization:slots:dataitems:addMapping', this._refreshHandler, this);
				this._content.on('change:visualization:slots:dataitems:removeMapping', this._refreshHandler, this);
			}
		}

		getAPI(type){
			if(type === 'internal'){
				return this._internalApi;
			}
		}

		_deregisterEvents () {
			if (!this._isExplore) {
				this._content.off('change:visualization:slots:dataitems:addMapping', this._refreshHandler, this);
				this._content.off('change:visualization:slots:dataitems:removeMapping', this._refreshHandler, this);
			}
		}

		destroy() {
			this._deregisterEvents();
			this._content = null;
		}

		_refreshHandler(options) {
			const transactionToken = options && options.transactionToken;
			return this._transaction.registerTransactionHandler(transactionToken || {}, this, function() {
				this.refresh();
			}.bind(this), options);
		}

		refresh(){
			const IDList = [this._content.getId()];
			if(_.isEqual(IDList, this._toolbarDock.getOwnerIDs())){
				const actions = ContentActionUtil.getContentActionList(this.dashboard, this.dashboard.getFeature('ContentActions'), IDList);
				this._toolbarDock.updateODTState(actions, IDList);
			}
		}
	}
	return Toolbar;
});
